import React, { useEffect, useState } from 'react';
import { getAllLanguagesOnLanguageID } from '../../data-sources/api';
import { Form } from 'react-bootstrap';

/**
 * LanguageSelect component that fetches and displays a list of languages based on the provided language ID.
 * 
 * @param {number} languageID - The ID of the language to fetch countries in.
 * @returns {JSX.Element} A form element containing a list of languages.
 */
export function LanguageSelect({ languageID }) {
    const [languages, setLanguages] = useState();

    /**
     * Fetches a list of languages based on the language ID
     */
    const fetchLanguages = async () => {
        try {
            const response = await getAllLanguagesOnLanguageID(languageID);
            setLanguages(response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }

    /**
     * Fetch languages when the language ID changes
     */
    useEffect(() => {
        fetchLanguages();
    }, [languageID]);

    return (
        <Form.Select>
            {languages?.length > 0 && languages.map((language) => {
                return (
                    <option value={language.spokenLanguageText} key={language.spokenLanguageText}>{language.spokenLanguageText}</option>
                );
            })}
        </Form.Select>
    );
}